<template>
  <div class="slideContainter">
    <div class="customer-prev slideButton" slot="button-prev">
      <span class="leftSingle single cursorPointer"></span>
    </div>
    <!-- 配置模板 -->
    <swiper :options="swiperOption" class="swiperCustomer cursorPointer" v-if="newfqArr.length">
      <swiper-slide :class="['swiperSlidecustomers',currentItemInd==index?'activeItem':'']" style="margin:0 10px;" v-for="(item,index) in newfqArr" :key="index">
        <div  @click="changeCurfile(index,item)">
          <div class="content">
            <div v-show="currentItemInd==index"></div>
            <img :src="item.thumbPath">
          </div>
          <!-- <img class="cover" @click="previewPdf(item)" src="@image/personalSign/preview_icon.png"> -->
          <div class="coverDscp">
            <p class="ellipsis ft12">{{item.name}}</p>
            <div class="handlerBox">
              <div>{{item.pages}}页</div>
              <div  @click.stop="previewPdf(item)"><img src="../../../../../assets/images/judicial/sreach_text.png"/></div>
              <!-- <el-tooltip placement="bottom" effect="light" popper-class="signPopperHandler">
                <div class="dotBox">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
                <div slot="content" class="conterntBox cursorPointer">
                 <div @click="deleteContract(item,index)">删除</div> 
                  <div @click="reNameContract(item,index)">重命名</div> 
                  
                </div>
              </el-tooltip> -->
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <!-- 上传文件 -->
    <swiper :options="swiperOption" class="swiperCustomer cursorPointer" v-if="contractList.length">
      <swiper-slide class="swiperSlidecustomer" v-for="(item,index) in contractList" :key="index">
        <div>
          <div class="content">
            <img :src="item.thumbPath">
          </div>
          <img class="cover" @click="previewPdf(item)" src="@image/personalSign/preview_icon.png">
          <div class="coverDscp">
            <p class="ellipsis ft12">{{item.fileName}}</p>
            <div class="handlerBox">
              <div>{{item.pages}}页</div>
              <el-tooltip placement="bottom" effect="light" popper-class="signPopperHandler">
                <div class="dotBox">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
                <div slot="content" class="conterntBox cursorPointer">
                  <div @click="deleteContract(item,index)">删除</div>
                  <div @click="reNameContract(item,index)">重命名</div>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiperSlidecustomerAdd" v-show="contractList.length<1" >
      <div v-loading="loadingUpload">
        <div class="content">
          <img src="@image/personalSign/pdf_file_icon.png">
        </div>
        <upload
          :url="'/file/uploadContract'"
          class="cover"
          :uploadType="'contract'"
          :curCount="contractList.length"
          @uploadSuccess="upload"
          @loading="loadingUpload=true"
          @loadingEnd="loadingUpload=false"
        >
          <img src="@image/personalSign/Addcontract_img_hov_pre.png" slot="uploadContent">
        </upload>
        <div class="coverDscp">上传本地文件</div>
      </div>
    </div>
    <div class="customer-next slideButton" slot="button-next">
      <span class="rightSingle single cursorPointer"></span>
    </div>
    <slot name="other"></slot>
    <Dialog
      :visible="deleteDialogShow"
      :dialogTitle="'提示'"
      :width="'400px'"
      @closeDialog="closeDialog('deleteDialogShow')"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>此操作将删除合同文件，是否继续？</p>
        </div>
        <div class="authHandlerBox">
          <div class="button buttonActive cursorPointer" @click="closeDialog('deleteDialogShow')">取消</div>
          <div class="button cursorPointer" @click="deleteContractConfrim">确定</div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="renameDialogShow"
      :dialogTitle="'合同文件重命名'"
      :width="'400px'"
      @closeDialog="closeDialog('renameDialogShow')"
    >
      <div class="signDialogs" slot="dialog">
        <div class="authDscp withInput">
          <p>请输入合同名称：</p>
          <el-input v-model="contractName" maxlength="50"></el-input>
        </div>
        <div class="authHandlerBox">
          <div class="button cursorPointer" @click="closeDialog('renameDialogShow')">取消</div>
          <div class="button cursorPointer buttonActive" @click="renameConfrim">确定</div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Upload from "@common/upload.vue";
import "swiper/dist/css/swiper.css";
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
export default {
  props: {
    state: {
      type: String,
      default: "add"
    },
    fqTemplateList:{
      type:Array,
      default:[]
    }
  },
  data() {
    return {
      loadingUpload: false,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 35,
        slidesPerGroup: 1,
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".customer-prev",
          prevEl: ".customer-next"
        }
      },
      contractName: "",
      deleteDialogShow: false,
      renameDialogShow: false,
      currentItem: {},
      currentIndex: 0,
      currentItemInd:0,
      newfqArr:[],
      contractList:[],
    };
  },
  components: {
    swiper,
    swiperSlide,
    Upload,
    Dialog
  },
  created(){},
  mounted() {},
  methods: {
    changeCurfile(index,item){
        this.currentItemInd=index;
        this.$bus.emit('curFqTemplate',item)
    },
    closeDialog(flag) {
      this.contractName = "";
      this[flag] = false;
    },
    setData(data) {
      this.contractList = data;
    },
    deleteContractConfrim() {
      BaseApi.createRpcToken(
        "/file/delete",
        { id: this.currentItem.id },
        "post"
      ).then(
        data => {
          this.contractList.splice(this.currentIndex, 1);
          this.deleteDialogShow = false;
          this.$message.success("删除成功");
        },
        () => {}
      );
    },
    getPDFpags(){
      let _this=this;
      if(this.fqTemplateList.length){ 
        console.log(this.fqTemplateList, 'this.fqTemplateList')
        this.changeCurfile(0,this.fqTemplateList[this.currentItemInd])
        let newfqArr=JSON.parse(JSON.stringify(this.fqTemplateList));
        this.newfqArr = newfqArr.filter(item => {
          return item.filePath
        })
        this.newfqArr.forEach((item,index)=>{
          PDFJS.getDocument({ url: item.pdfPath }).then( function getPdfHelloWorld(pdf) {
            item.pages=pdf.numPages;
            _this.newfqArr.splice(index,1,item)
          })
        })
      }
      if (this.contractList.length) {
        this.contractList.forEach((item,index)=>{
          PDFJS.getDocument({ url: item.filePath }).then( function getPdfHelloWorld(pdf) {
            item.pages=pdf.numPages;
            _this.contractList.splice(index,1,item)
          })
        })
      }
    },
    renameConfrim() {
      if (!this.contractName) {
        this.$message.error('请输入合同名称');
        return;
      }
      BaseApi.createRpcToken(
        "/file/rename",
        {
          id: this.currentItem.id,
          fileName: this.contractName
        },
        "post"
      )
        .then(
          data => {
            this.renameDialogShow = false;
            this.$set(this.currentItem, "fileName", this.contractName);
            this.$message.success("重命名成功");
          },
          () => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    deleteContract(item, index) {
      this.currentItem = item;
      this.currentIndex = index;
      this.deleteDialogShow = true;
    },
    reNameContract(item, index) {
      this.currentItem = item;
      this.currentIndex = index;
      this.renameDialogShow = true;
    },
    upload(item) {
      this.contractList.push(item.datas.fileInfo);
      this.getPDFpags();
    },
    previewPdf(item) {
      this.$Method.previewPdf(item.pdfPath||item.filePath);
    },
    save() {
      if (this.fqTemplateList[this.currentItemInd]) {
        return {
          data: this.fqTemplateList[this.currentItemInd],
          valid: true
        };
      } else {
        return {
          data: [],
          valid: false,
          validMessage: "至少选择一个合同文件"
        };
      }
    },
    // 提交自定义上传文件
    contractListSubmit() {
      if (this.contractList) {
        return {
          data: this.contractList,
          valid: true
        };
      } else {
        return {
          data: [],
          valid: false,
          validMessage: "至少选择一个合同文件"
        };
      }
    }
  },
  watch:{
    'fqTemplateList'(){
       this.getPDFpags();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.signPopperHandler {
  width: 80px;
  padding: 0 !important;
  background: #ffffff;
  border: 1px solid #e4e8eb !important;
  box-shadow: 0 1px 1px 0 rgba(160, 160, 160, 0.5) !important;
  .conterntBox {
    div {
      line-height: 30px;
      text-align: align;
      color: #e88078;
      font-size: 14px;
      text-align: center;
    }
    & > div:first-child {
      border-bottom: 1px solid #e4e8eb;
    }
  }
}
.slideContainter {
  width: 100%;
  height: 100%;
  display: flex;
  .swiperCustomer {
    // flex: 1;
    max-width: calc(100% - 500px);
    margin: 0;
    .swiperSlidecustomers {
      margin: 0;
      width: 160px;
      height: 200px;
      position: relative;
      box-sizing: border-box;
      border: 1px dashed #e4e8eb;
      margin-left: 10px;
      margin-right: 10px !important;
      .content {
        width: 100%;
        height: 200px;
        box-sizing: border-box;
        padding: 10px;
        background-color: #f4f4f4;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        div{
          position: absolute;
          top:0px;
          left: 0px;
          width: 100%;
          height:100%;
          background: #FF7172;
          opacity: 0.1;
        }
      }
      .cover {
        display: none;
      }
      &:hover {
        .cover {
          position: absolute;
          display: block;
          width: 100%;
          height: 146px;
          left: 0;
          top: 0;
          z-index: 1;
        }
      }
      .coverDscp {
        position: absolute;
        z-index: 2;
        width: 158px;
        box-sizing: border-box;
        height: 55px;
        bottom: 0;
        padding: 5px;
        border: 1px dashed #e4e8eb;
        background-color: white;
        border-left: 0px; 
         border-right: 0px;
        p {
          line-height: 17px;
          color: #646464;
        }
        .handlerBox {
          margin-top: 5px;
          height: 17px;
          line-height: 19px;
          display: flex;
          color: #969696;
          font-size: 12px;
          justify-content: space-between;
          align-items: center;
          img{
            height: 12px;
            width: 62px;
          }
          .dotBox {
            height: 20px;
            width: 3px;
            .dot {
              margin-bottom: 3px;
              height: 3px;
              width: 3px;
              background-color: #e88078;
            }
          }
        }
      }
    }
    .activeItem{
      border-color:#FF4D4F;
       .coverDscp{
         border-color:#FF4D4F;
      }
    }
  }
  .slideButton {
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    .single {
      width: 11px;
      height: 17px;
      background-size: 100% 100%;
    }
    .rightSingle {
      background: url(./../../../../../assets/images/personalSign/right_icon_nor.png);
      &:hover {
        background: url(./../../../../../assets/images/personalSign/right_icon_hov.png);
      }
    }
    .leftSingle {
      background: url(./../../../../../assets/images/personalSign/left_icon_nor.png);
      &:hover {
        background: url(./../../../../../assets/images/personalSign/left_icon_hov.png);
      }
    }
  }
}.swiperCustomer {
    // flex: 1;
    max-width: calc(100% - 500px);
    margin: 0;
    .swiperSlidecustomer {
      margin: 0;
      width: 160px;
      height: 200px;
      position: relative;
      .content {
        width: 100%;
        height: 200px;
        box-sizing: border-box;
        padding: 10px;
        background-color: #f4f4f4;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .cover {
        display: none;
      }
      &:hover {
        .cover {
          position: absolute;
          display: block;
          width: 100%;
          height: 146px;
          left: 0;
          top: 0;
          z-index: 1;
        }
      }
      .coverDscp {
        position: absolute;
        z-index: 2;
        width: 160px;
        box-sizing: border-box;
        height: 55px;
        bottom: 0;
        padding: 5px;
        border: 1px solid #e4e8eb;
        background-color: white;
        p {
          line-height: 17px;
          color: #646464;
        }
        .handlerBox {
          margin-top: 5px;
          height: 17px;
          line-height: 17px;
          display: flex;
          color: #969696;
          font-size: 12px;
          justify-content: space-between;
          .dotBox {
            height: 20px;
            width: 3px;
            .dot {
              margin-bottom: 3px;
              height: 3px;
              width: 3px;
              background-color: #e88078;
            }
          }
        }
      }
    }
  }
</style>
